import { render } from "./Tools.vue?vue&type=template&id=3efd9454&scoped=true"
const script = {}

import "./Tools.vue?vue&type=style&index=0&id=3efd9454&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efd9454"]])

export default __exports__